
/* ═══════════════════════════════════════════
   Soriega custom JS  —  soriega-custom.js
   ═══════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Scroll-reveal for .sg-reveal elements ── */
  function initReveal() {
    const els = document.querySelectorAll('.sg-reveal');
    if (!els.length) return;
    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('sg-visible'); io.unobserve(e.target); }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── Sticky nav background tint on scroll ── */
  function initNavScroll() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 30) {
        header.style.background = 'rgba(255,255,255,0.95)';
      } else {
        header.style.background = 'rgba(255,255,255,0.85)';
      }
    }, { passive: true });
  }

  /* ── Card hover-float (reinforces CSS) ── */
  function initCardHover() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        this.style.transform = 'translateY(-6px)';
        this.style.boxShadow = '0 16px 40px rgba(0,0,0,0.10)';
      });
      card.addEventListener('mouseleave', function () {
        this.style.transform = '';
        this.style.boxShadow = '';
      });
    });
  }

  /* ── Init ── */
  function boot() {
    initReveal();
    initNavScroll();
    initCardHover();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* SG STORE PICKER v2 */
(function () {
  'use strict';

  function initStorePickers() {
    document.querySelectorAll('[data-sg-store-picker]').forEach(function (picker) {
      if (picker.dataset.sgStoreReady === 'true') return;
      picker.dataset.sgStoreReady = 'true';

      var options = Array.prototype.slice.call(
        picker.querySelectorAll('[data-sg-store-option]')
      );
      var input = picker.querySelector('[data-sg-store-input]');
      var summary = picker.querySelector('[data-sg-store-summary]');
      var form = picker.closest('form');
      var quantity = form && form.querySelector('.quantity__input');
      var submit = form && form.querySelector('[type="submit"]');

      function selectStore(option) {
        var stock = Number(option.getAttribute('data-store-stock') || 0);
        var label = option.getAttribute('data-store-label') || '';
        options.forEach(function (candidate) {
          var selected = candidate === option;
          candidate.classList.toggle('is-selected', selected);
          candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
          candidate.setAttribute('aria-checked', selected ? 'true' : 'false');
          candidate.setAttribute('data-selected', selected ? 'true' : 'false');
        });
        if (input) input.value = label;
        if (summary) {
          summary.textContent = stock > 0
            ? 'Stock disponible en ' + label + ': ' + stock + ' unidad' + (stock === 1 ? '' : 'es') + '.'
            : 'Esta sede está agotada.';
        }
        if (quantity && stock > 0) {
          quantity.max = String(stock);
          quantity.setAttribute('data-max', String(stock));
          var current = Number(quantity.value || 1);
          if (!Number.isFinite(current) || current < 1) quantity.value = '1';
          if (current > stock) quantity.value = String(stock);
        }
        if (submit) {
          submit.disabled = stock <= 0;
          submit.classList.toggle('button--sold-out', stock <= 0);
          var text = submit.querySelector('span');
          if (text && stock > 0) text.textContent = 'Agregar al carrito';
        }
      }

      options.forEach(function (option) {
        option.addEventListener('click', function () {
          if (!option.disabled) selectStore(option);
        });
      });

      var firstAvailable = options.find(function (option) {
        return !option.disabled && Number(option.getAttribute('data-store-stock') || 0) > 0;
      });
      if (firstAvailable) selectStore(firstAvailable);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStorePickers);
  } else {
    initStorePickers();
  }
})();

/* SG DESKTOP CATEGORY DROPDOWN v1 */
(function () {
  'use strict';

  function initDesktopCategoryDropdown() {
    var details = document.querySelector('#Details-DesktopCategories');
    var panel = document.querySelector('#DesktopCategoriesPanel');
    if (!details || !panel || details.dataset.sgReady === 'true') return;
    details.dataset.sgReady = 'true';

    function positionPanel() {
      var header = document.querySelector('.header-wrapper');
      if (!header) return;
      document.documentElement.style.setProperty(
        '--sg-desktop-menu-top',
        header.getBoundingClientRect().bottom + 'px'
      );
    }

    function syncState() {
      var trigger = details.querySelector('summary');
      if (trigger) trigger.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (details.open) positionPanel();
    }

    details.addEventListener('toggle', syncState);
    document.addEventListener('click', function (event) {
      if (details.open && !details.contains(event.target)) details.removeAttribute('open');
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && details.open) {
        details.removeAttribute('open');
        details.querySelector('summary').focus();
      }
    });
    window.addEventListener('resize', positionPanel, { passive: true });
    window.addEventListener('scroll', positionPanel, { passive: true });
    positionPanel();
    syncState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDesktopCategoryDropdown);
  } else {
    initDesktopCategoryDropdown();
  }
})();
